import { render } from "./MyAlertDialog.vue?vue&type=template&id=9a8f50f0&ts=true"
import script from "./MyAlertDialog.vue?vue&type=script&lang=ts"
export * from "./MyAlertDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__